import * as React from "react";

export function RadioDot({ checked, className }: { checked: boolean; className?: string }) {
  return (
    <span
      className={`flex-shrink-0 w-4 h-4 rounded-full border-2 flex items-center justify-center transition-colors ${
        checked ? "border-cornflower-blue-500" : "border-slate-300"
      } ${className ?? ""}`}
    >
      {checked && <span className="w-2 h-2 rounded-full bg-cornflower-blue-500" />}
    </span>
  );
}

interface RadioOptionProps {
  checked: boolean;
  onChange: () => void;
  label: React.ReactNode;
  name?: string;
  value?: string;
  disabled?: boolean;
  className?: string;
}

export default function RadioOption({ checked, onChange, label, name, value, disabled, className }: RadioOptionProps) {
  return (
    <label
      className={`flex items-center gap-2 select-none ${
        disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
      } ${className ?? ""}`}
    >
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="sr-only"
      />
      <RadioDot checked={checked} />
      <span className="text-sm text-slate-700 leading-tight">{label}</span>
    </label>
  );
}
